import type { InAppAnnouncementRouter } from "replo-publisher/src/trpc/routers/inAppAnnouncement";

import { createTrpcRouterConfig } from "@v2/trpc/config";
import { getNamespacedQueryClient } from "@v2/trpc/trpc";

export const { client: inAppAnnouncementClient } =
  createTrpcRouterConfig<InAppAnnouncementRouter>({
    path: "inAppAnnouncement",
    queryClient: getNamespacedQueryClient("inAppAnnouncement"),
  });
